'use client';

import { usePushProps, usePush } from '@/common/usePush';
import { PFButton } from './PFButton';
import { CiBellOn, CiBellOff } from 'react-icons/ci';
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5';
import { useEffect, useState } from 'react';
import { PFText } from './PFText';
import Spinner from './Spinner';
import * as stylex from '@stylexjs/stylex';
import '@/common/tokens.stylex';
import { colors } from '@/common/tokens.stylex';
type Props = {
  tag: usePushProps;
  variant?: 'baseRounded' | 'binIcon' | 'base';
  toggleGeneral?: boolean;
};
export function PushAbo(props: Props) {
  const {
    toggleGeneral,
    variant
  } = props;
  const {
    askPermission,
    subscribeButtonOnClick,
    isSubscribed
  } = usePush(props.tag, toggleGeneral);
  const [loading, setLoading] = useState(true);
  useEffect(() => setLoading(false), []);
  if (variant === 'binIcon') {
    return <button onClick={event => {
      askPermission().then(() => {
        subscribeButtonOnClick(event);
      }).catch(err => {
        console.error(err);
      });
    }} disabled={loading}>
        {loading ? <Spinner /> : <>
            <PFText size="base">
              {isSubscribed ? <IoCheckbox className="xw4jnvo x1qx5ct2 x6bodad" /> : <IoSquareOutline className="xw4jnvo x1qx5ct2 x6bodad" />}
            </PFText>
          </>}
      </button>;
  }
  return <PFButton onClick={event => {
    askPermission().then(() => {
      subscribeButtonOnClick(event);
    }).catch(err => {
      console.error(err);
    });
  }} variant={'baseRounded'} style={styles.button} disabled={loading}>
      {loading ? <Spinner /> : <>
          {isSubscribed ? <CiBellOff className="xxk0z11 xvy4d1p" /> : <CiBellOn className="xxk0z11 xvy4d1p" />}
          <PFText size="small" style={styles.label}>
            {isSubscribed ? 'Push Deaktivieren' : 'News per Push abonnieren'}
          </PFText>
        </>}
    </PFButton>;
}
const styles = {
  button: {
    kmVPX3: "xe8ttls",
    kg3NbH: "xdqyycr",
    kzqmXN: "x1dz1jew",
    kAzted: "x1ba4aug",
    $$css: true
  },
  label: {
    k63SB2: "xo1l8bm",
    $$css: true
  }
};